import { OnbOptionType } from '../../../../types';
import { LayoutDataType } from '../../types';

export const ETHNICITY_OPTIONS: OnbOptionType<LayoutDataType['ethnicity']>[] = [
  {
    id: 'african',
    title: 'African',
  },
  {
    id: 'asian',
    title: 'Asian',
  },
  {
    id: 'european',
    title: 'European',
  },
  {
    id: 'arabian',
    title: 'Arabian',
  },
];
